import React from 'react';
import { LOCATIONS } from '../utils/locations';
import './LocationDropdown.css';

function LocationDropdown({ value, onChange }) {
    // Sort locations by name for display
    const sortedLocations = [...LOCATIONS].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    return (
        <div className="location-dropdown">
            <label htmlFor="location">Select Location *</label>
            <select
                id="location"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="location-select"
            >
                <option value="">-- Choose a location --</option>
                {sortedLocations.map((location) => (
                    <option key={location.id} value={location.id}>
                        {location.name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default LocationDropdown;
